var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKebabMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9214,
    cy: 5.92145,
    r: 1.92145,
    fill: "#646471"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9214,
    cy: 11.7643,
    r: 1.92145,
    fill: "#646471"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9214,
    cy: 17.6072,
    r: 1.92145,
    fill: "#646471"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebabMenu);
export default __webpack_public_path__ + "static/media/kebab-menu.9a81835aee81d3cddd13b6d285f5c34f.svg";
export { ForwardRef as ReactComponent };